const THREE = require('three') 
 
class Moons extends THREE.Group {

  constructor(config) {

    super(); 
  
    this.setup();
    this.resize() 
  } 

  setup() {

    this.moon_one = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(128 * 0.2, 128 * 0.2), 
      new THREE.MeshBasicMaterial({
        map: new THREE.TextureLoader().load(require('@/assets/img/moons/planet_1.png')),
        transparent: true
      })
    );  
    this.moon_one.position.y = -700;
    this.moon_one.position.x = 400;
    this.moon_one.position.z = -1000; 

    this.moon_two = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(128 * 0.2, 128 * 0.2), 
      new THREE.MeshBasicMaterial({
        map: new THREE.TextureLoader().load(require('@/assets/img/moons/planet_2.png')),
        transparent: true
      })
    );  
    this.moon_two.position.y = -200;
    this.moon_two.position.x = 150;
    this.moon_two.position.z = -300; 

    this.moon_three = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(128 * 0.2, 128 * 0.2), 
      new THREE.MeshBasicMaterial({
        map: new THREE.TextureLoader().load(require('@/assets/img/moons/planet_3.png')),
        transparent: true
      })
    );  
    this.moon_three.position.y = 100;
    this.moon_three.position.x = -400;
    this.moon_three.position.z = -1300; 
 
    this.moon_four = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(128 * 0.15, 128 * 0.15), 
      new THREE.MeshBasicMaterial({
        map: new THREE.TextureLoader().load(require('@/assets/img/moons/planet_4.png')),
        transparent: true
      })
    );  
    this.moon_four.position.y = -200;
    this.moon_four.position.x = -300;
    this.moon_four.position.z = -600; 

    this.moon_five = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(128 * 0.2, 128 * 0.2), 
      new THREE.MeshBasicMaterial({
        map: new THREE.TextureLoader().load(require('@/assets/img/moons/planet_5.png')),
        transparent: true
      })
    );  
    this.moon_five.position.y = -600;
    this.moon_five.position.x = -200;
    this.moon_five.position.z = -1100; 

    this.moon_six = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(128 * 0.2, 128 * 0.2), 
      new THREE.MeshBasicMaterial({
        map: new THREE.TextureLoader().load(require('@/assets/img/moons/planet_6.png')),
        transparent: true
      })
    );  
    this.moon_six.position.y = 50;
    this.moon_six.position.x = 300;
    this.moon_six.position.z = -1500; 

    this.moon_seven = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(128 * 0.2, 128 * 0.2), 
      new THREE.MeshBasicMaterial({
        map: new THREE.TextureLoader().load(require('@/assets/img/moons/planet_7.png')),
        transparent: true
      })
    );  
    this.moon_seven.position.y = -50;
    this.moon_seven.position.x = 300;
    this.moon_seven.position.z = -900;

    this.add(this.moon_one);
    this.add(this.moon_two)
    this.add(this.moon_three);
    this.add(this.moon_four);
    this.add(this.moon_five);
    this.add(this.moon_six);
    this.add(this.moon_seven); 
  }

  resize() {  }
 
 
}

export default Moons